"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLOR_MAP = void 0;
// WARN: this color file is generated and synced by script, DO NOT modify it manually!!!
exports.COLOR_MAP = {
    black: '#8C8C8C',
    blackBlue: '#9FA1BB',
    blue: '#55CDFF',
    brown: '#6E382D',
    deepPurple: '#7B67EE',
    green: '#52C41B',
    indigo: '#5586FF',
    orange: '#FFAB00',
    pink: '#FF708B',
    purple: '#B35FF5',
    red: '#E33E38',
    tangerine: '#FF7A00',
    teal: '#30C28B',
    yellow: '#FFD43A',
};
//# sourceMappingURL=_colors.js.map